import { DiagnosisItem } from "../../diagnosis.model";
import { Tooth } from "../../../../odontogram/odontogram.model";
import { ItemValidators } from "../../../item-validators";
import { AbstractCondition } from "../condition";

export class Implant extends AbstractCondition {
  static validate(
    item: DiagnosisItem,
    odontogram: Tooth[],
    items: DiagnosisItem[],
  ): boolean {
    // validate teeth selected
    if (!ItemValidators.hasTeethSelected(item)) {
      return false;
    }

    // validate implant option
    if (!ItemValidators.hasOptionSelected(item)) {
      return false;
    }

    return true;
  }

  static apply(odontogram: Tooth[], item: DiagnosisItem): Tooth[] {
    const option = item.options.options.join(" ");

    odontogram
      .filter((tooth) => item.teeth.indexOf(tooth.number) > -1)
      .forEach((tooth) => {
        tooth.diagnosis.push({ condition: item.condition, options: option });
        tooth.missing = true;
        tooth.implant = true;
      });

    return odontogram;
  }

  static getDiagnosis360Changes(item: DiagnosisItem): any {
    const update = {};

    if (
      item.options.options.includes("boneloss") ||
      item.options.options.includes("recession")
    ) {
      // if the implant has bone loss or gingival recession
      update["gum_disease"] = true;
    }

    if (!item.options.options.includes("ok")) {
      // if the implant has any problem
      update["problems_existing_treatments"] = true;
    }

    return Object.keys(update).length > 0 ? update : null;
  }

  static getDescriptionIdentifiers(item: DiagnosisItem): string[] {
    return item.options.options.map((option) => `implant_${option}`);
  }

  static supports(condition: string): boolean {
    return condition === "implant";
  }

  static getItemResume(item: DiagnosisItem): any {
    return [
      {
        name: "status",
        value: item.options.options.map(
          (option) => "diagnosis.options." + option,
        ),
      },
    ];
  }

  static getTableData(item: DiagnosisItem): any {
    return [
      "",
      item.options.options.map((option) => "diagnosis.options." + option),
    ];
  }
}



// WEBPACK FOOTER //
// /app/src/app/core/store/plan-editor/diagnosis/conditions/missing/implant.ts